export default function () {
    return function (input) {
        for (var i = 0, l = input.length; i < l; i++) {
            for (var j = 1, clsNo = input[i].classes.length; j < clsNo; j++)
                if (input[i].classes[j].classNo === input[i].classes[j - 1].classNo) {
                    input[i].classes[j].hiddenTitle = true;
                } else {
                    input[i].classes[j].hiddenTitle = false;
                }
        }
    }
};